import React, { Component } from 'react';
import { Grid, Cell } from 'react-mdl';
import Education from './education';
import Experience from './experience';
import Skills from './skills';
import education from './education.png';
import WorkIcon from './work.png';
import work from './work.png';
import skill from './skill.png';
import personal from './personal.png';
import StarRatings from './StarRatings';
import Timeline from './Timeline';
import {  TimelineItem }  from 'vertical-timeline-component-for-react';
import {  VerticalTimelineElement }  from 'react-vertical-timeline-component';
import VerticalTimeline from './VerticalTimeline';
import ReactCardFlip from 'react-card-flip';
import ButtonExampleEmphasis from './Button';
import langue from './langue.png';
import blog from './blog.png';
import read from './read.png';
import movie from './movie.png';
import fun from './fun.png';

class Resume extends Component {
  render() {
    return(
      <div>
        <Grid className="CV">
          <Cell col={4}>
            <div style={{textAlign: 'center'}}>
              <img
                src="https://i.ibb.co/4N4PHB1/69571101-1308850042626129-1167000403108167680-n.jpg"
                alt="avatar"
                className="avatar-img"
                style={{height: '200px'}}
                 />
            </div>

            <h2 style={{paddingTop: '2em'}}>Selmi Ahmed</h2>
            <h4 style={{color: 'grey'}}>Web Developer</h4>
            <hr style={{borderTop: '3px solid #833fb2', width: '50%'}}/>
            <p>I'm a IT management student with a focus on web development. I'm hardworking, diligent, and dedicated—all qualities I put forward in everything I do.</p>
            <hr style={{borderTop: '3px solid #833fb2', width: '50%'}}/>
            <h5>Address</h5>
            <p>27 Rue Abu Dhar Al-Ghifari Cité Avicenne-Tunis</p>
            <h5>Phone</h5>
            <p>55481874</p>
            <h5>Email</h5>
            <p>ahmed_selmi@outlook.com</p>
            <h5>Web</h5>
            <p>mywebsite.com</p>
            <hr style={{borderTop: '3px solid #833fb2', width: '50%'}}/>
<div>
  <a href="./CVFrancais.pdf" download="CVFrancais.pdf"><button  >Download CV</button></a>
</div>

          </Cell>
          <Cell className="resume-right-col" col={8} >
          <img src={education} style={{  float: 'left'}}
              className="education-img"/>
            <h2 style={{  float: 'left',paddingTop:'20px'}}>Education</h2>

  <Timeline className="Time" lineColor={'#ddd'} >
  <TimelineItem 
    key="001"
    dateText="2017"
    style={{color: 'rgb(128, 128, 192)',paddingTop:'5em' }}
     dateInnerStyle={{
      background: 'rgb(128, 128, 192)'}}

  >
    <h2 style={{ color: '#ffffff' }}>Secondary High School Ibn Sina</h2>
    <h4 style={{ color: '#ffffff' }}>Bachelor of Experimental Sciences</h4>
    <p style={{ color: '#ffffff' }}>
    Mention: Good

      
    </p>

  </TimelineItem>
   <TimelineItem
    key="002"
    dateText="2017-present"
    style={{color: 'rgb(128, 128, 192)'  }}
     dateInnerStyle={{
      background: 'rgb(128, 128, 192)'}}
  >
    <h2 style={{ color: '#ffffff' }}>High Institute of Management Tunis</h2>
    <h4 style={{ color: '#ffffff' }}>Fundamental Degree in Management Computer Science</h4>
    <p style={{ color: '#ffffff' }}>
 
    </p>

  </TimelineItem>

</Timeline>

                <hr style={{borderTop: '3px solid #e22947'}} />


<img src={work}  
              className="work-img"style={{  float: 'left'}}/>
              <h2 style={{  float: 'left',paddingTop:'20px'}}>Professional Experience</h2>
      <Timeline lineColor={'#ddd'}>
<TimelineItem
    key="002"
    dateText="August  2018 "
    style={{color: 'rgb(43, 157, 213)',paddingTop:'5em' }}
    dateInnerStyle={{
      background: 'rgb(43, 157, 213)'}}
      
  >
    
    <h2 style={{ color: '#ffffff' }}>Compagnie Tunisienne de Navigation (CTN)</h2>
    <h4 style={{ color: '#ffffff' }}>Intern </h4>
    <p style={{ color: '#ffffff' }}>
     First Internship in Professional Environnement
    </p>

  </TimelineItem>

<TimelineItem
    key="002"
    dateText="August  2019"
    style={{color: 'rgb(43, 157, 213)' }}
    dateInnerStyle={{
      background: 'rgb(43, 157, 213)'}}










  >



    <h2 className="vertical-timeline-element-title" style={{ color: '#ffffff' }}>Société Tunisienne de Banque (STB)</h2>
    <h4 style={{ color: '#ffffff' }}>Intern </h4>
    <p style={{ color: '#ffffff' }}>
Summer Internship    </p>

  </TimelineItem>

<TimelineItem
    key="003"
    dateText="2019"
    style={{color: 'rgb(43, 157, 213)' }}
    dateInnerStyle={{
      background: 'rgb(43, 157, 213)'}}
      
  >
    
    <h2 style={{ color: '#ffffff' }}>OpenSourceFriday </h2>
    <h4 style={{ color: '#ffffff' }}>Contributor </h4>
    <p style={{ color: '#ffffff' }}>
Participate in some OpenSource projects like Zero To Mastery    </p>

  </TimelineItem>
<TimelineItem
    key="004"
    dateText="2019"
    style={{color: 'rgb(43, 157, 213)' }}
    dateInnerStyle={{
      background: 'rgb(43, 157, 213)'}}
      
  >
    
    <h2 style={{ color: '#ffffff' }}>Medium.com</h2>
    <h4 style={{ color: '#ffffff' }}>Blogger</h4>
    <p style={{ color: '#ffffff' }}>
Publish Tech realted Articles 
    </p>

  </TimelineItem>
<TimelineItem
    key="005"
    dateText="2019"
    style={{color: 'rgb(43, 157, 213)' }}
    dateInnerStyle={{
      background: 'rgb(43, 157, 213)'}}
      
  >
    
    <h2 style={{ color: '#ffffff' }}>UpWork</h2>
    <h4 style={{ color: '#ffffff' }}>FreeLancer</h4>
    <p style={{ color: '#ffffff' }}>
    </p>

  </TimelineItem>



</Timeline>
            
              <hr style={{borderTop: '3px solid #e22947'}} />
              <img src={skill} style={{  float: 'left'}} 
              className="skill-img"/>
              <h2 style={{  float: 'left',paddingTop:'20px'}}>Skills</h2>
              <ul className="list">
              <li  style={{textAlign:'center',paddingTop:'2.5em'}}>Hard Skills</li>
              <Skills 
                skill="Javascript"
                progress={70}
                />
                <Skills
                  skill="HTML/CSS"
                  progress={80}
                  />
                  <Skills 
                skill="Java"
                progress={60}
                />
                  <Skills 
                skill="C#"
                progress={60}
                />
                 <Skills 
                skill="PhotoShop"
                progress={60}
                />
                  <Skills 
                skill="Python"
                progress={30}
                />
                  <Skills
                    skill="NodeJS"
                    progress={50}
                    />
                    <Skills
                      skill="React"
                      progress={70}
                      />
                       <Skills
                  skill="SQL"
                  progress={50}
                  />
                       <Skills
                  skill="UML"
                  progress={70}
                  />
                    <Skills 
                skill="Scrum"
                progress={60}
                />
                   <Skills
                  skill="Digital Marketing"
                  progress={60}
                  /><br></br>
                  <li style={{textAlign:'center'}}>Soft Skills</li>
                   <Skills
                  skill="Creativity"
                  progress={70}
                  />
                   <Skills
                  skill="Team Work"
                  progress={80}
                  />
                   <Skills
                  skill="Time Management  "
                  progress={70}
                  />
                    <Skills
                  skill="Problem Solving  "
                  progress={70}
                  /></ul>
                <hr style={{borderTop: '3px solid #e22947'}} />
                <img src={personal} style={{  float: 'left'}} 
              className="personal-img"/>
                <h2 style={{  float: 'left',paddingTop:'10px'}}>Professional Development</h2>
                <ul className="moocs" style={{ paddingTop:'5em'}}>
                  <li>Udemy Certified</li>
                  <li><b>FreeCodeCamp :</b> Javascript Algorithms And Data Structures Certification</li>
                  <li><b>Udacity :</b> Front End Development Track Certification || Full Stack Development Track Certification</li>
                  <li><b>ChallengeRocket:</b> Participation in live Coding Challenges online.</li>
                </ul>
                <hr style={{borderTop: '3px solid #e22947'}} />
               
               <img src={langue}  
              style={{  float: 'left'}}/>
              <h2 style={{  float: 'left',paddingTop:'10px'}}>Languages</h2>
<br></br>
<div className="langue">
<h4 style={{ paddingTop:'2.5em'}}>English (Upper Intermediate level).</h4><p></p><StarRatings numberOfStars={6} starDimension="30px" starSpacing="5px" starRatedColor="rgb(236, 225, 19)" rating={4} /><br></br>
<br></br>
<h4>French (B1 level)</h4><StarRatings  numberOfStars={6} starDimension="30px" starSpacing="5px" starRatedColor="rgb(236, 225, 19)" rating={3}  />
<br></br>
<br></br>
<h4>German (A2 level)</h4><StarRatings  numberOfStars={6} starDimension="30px" starSpacing="5px" starRatedColor="rgb(236, 225, 19)" rating={2}  />
 </div>
 <hr style={{borderTop: '3px solid #e22947'}} />
                <img src={fun}  
              style={{  float: 'left'}}/>
              <h2 style={{  float: 'left',paddingTop:'10px'}}>Hobbies</h2>
<br></br><br></br><br></br>

<div className="hobbies" >

<div class="flip-card">
  <div class="flip-card-inner">
    <div class="flip-card-front">
    <i class="fa fa-film fa-5x white " aria-hidden="true" style={{width:'100px',height:'100px'}}></i>

    </div>
    <div class="flip-card-back">
      <h3 style={{textAlign:'center'}} >Films</h3> 
     
    </div>
  </div>
</div>

<div class="flip-card">
  <div class="flip-card-inner">
    <div class="flip-card-front">
<i class="fa fa-camera-retro fa-5x white"></i>

    </div>
    <div class="flip-card-back">
      <h3 style={{textAlign:'center'}} >Photography</h3> 
     
    </div>
  </div>
</div>
<div class="flip-card">
  <div class="flip-card-inner">
    <div class="flip-card-front">
<i class="fa fa-book fa-5x white" aria-hidden="true"></i>

    </div>
    <div class="flip-card-back">
      <h3 style={{textAlign:'center'}} >Reading</h3> 
     
    </div>
  </div>
</div>


<div class="flip-card">
  <div class="flip-card-inner">
    <div class="flip-card-front">
<i class="fa fa-medium fa-5x white" aria-hidden="true"></i>

    </div>
    <div class="flip-card-back">
      <h3 style={{textAlign:'center'}} >Blogging</h3> 
     
    </div>
  </div>
</div>
<div class="flip-card">
  <div class="flip-card-inner">
    <div class="flip-card-front">
<i class="fa fa-music fa-5x white" aria-hidden="true"></i>

    </div>
    <div class="flip-card-back">
      <h3 style={{textAlign:'center'}} >Music</h3> 
     
    </div>
  </div>
</div>

</div>



          </Cell>
        </Grid>
      </div>
    )
  }
}

export default Resume;



// WEBPACK FOOTER //
// ./src/components/resume.js